import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ordersApi } from '../api/orders';
import { toErrorMessage } from '../api/client';
import { useStores } from '../auth/StoreContext';
import { Card, PageHead } from '../components/ui';
import { Empty, ErrorState, Loading } from '../components/DataStates';
import { StoreSelector } from '../components/StoreSelector';
import { dateTime, money } from '../lib/format';

export function RefundsPage() {
  const { selectedStoreId } = useStores();

  const q = useQuery({
    queryKey: ['refunds', selectedStoreId],
    enabled: selectedStoreId != null,
    queryFn: () => ordersApi.refunds(selectedStoreId),
  });

  return (
    <>
      <PageHead
        title="Refunds"
        subtitle="Refunds are recorded from a bill's detail page and always reference the original bill."
        actions={<StoreSelector />}
      />
      <Card>
        {selectedStoreId == null ? (
          <Empty icon="🏬" title="Select a store" />
        ) : q.isLoading ? (
          <Loading />
        ) : q.isError ? (
          <ErrorState message={toErrorMessage(q.error)} onRetry={q.refetch} />
        ) : !q.data || q.data.length === 0 ? (
          <Empty icon="↩️" title="No refunds recorded" />
        ) : (
          <div className="table-wrap">
            <table className="data">
              <thead>
                <tr>
                  <th>Bill No.</th><th>Date / Time</th>
                  <th className="text-right">Refund Amount</th><th>Reason</th><th></th>
                </tr>
              </thead>
              <tbody>
                {q.data.map((r) => (
                  <tr key={r.id}>
                    <td><strong>{r.billNumber || `#${r.orderId}`}</strong></td>
                    <td>{dateTime(r.createdAt)}</td>
                    <td className="text-right">{money(r.amount)}</td>
                    <td>{r.reason || '—'}</td>
                    <td className="text-right">
                      <Link className="btn btn-secondary btn-sm" to={`/bills/${r.orderId}`}>View Bill</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
